module.exports = __webpack_public_path__ + "static/media/art30.1686e038.jpg";